export default __webpack_public_path__ + "static/media/add-shipping-information.27fc9a63.png";